import React, { useState } from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { siteContent } from '../../content';
import { Link, LinkMail } from '@randajan/jet-react/dom/link';

import "./Contact.scss";

const copyLabels = {
    idle: "Kopírovat e-mail",
    copied: "Zkopírováno",
    failed: "Kopírování selhalo"
};

const getMapUrl = location => {
    const query = encodeURIComponent(location.mapQuery);
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

const writeClipboard = text => {
    if (navigator.clipboard?.writeText) { return navigator.clipboard.writeText(text); }

    const input = document.createElement("textarea");
    input.value = text;
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand("copy");
    input.remove();
    if (!copied) { throw new Error("copy_failed"); }
}


export const Contact = (props)=>{
    const {} = props;
    const { email, lead, locations, status, title } = siteContent.contact;
    const [copyState, setCopyState] = useState("idle");

    const copyEmail = async ()=>{
        try {
            await writeClipboard(email);
            setCopyState("copied");
        } catch (err) {
            setCopyState("failed");
        }

        setTimeout(_=>setCopyState("idle"), 1600);
    }
    
    return (
        <Block className="Contact" caption={title}>
            <header>
                <span>{status}</span>
                <p>{lead}</p>
                <div className="Contact__emailCard">
                    <strong>E-mail</strong>
                    <div className="Contact__emailActions">
                        <LinkMail className="Contact__mail" to={email}>{email}</LinkMail>
                        <button className="Contact__copy" type="button" aria-live="polite" onClick={copyEmail}>{copyLabels[copyState]}</button>
                    </div>
                </div>
            </header>
            <div className="Contact__locations">
                {locations.map(location=>(
                    <div className="Contact__location" key={location.title}>
                        <strong>{location.title}</strong>
                        <address>
                            {location.lines.map(line=><span key={line}>{line}</span>)}
                        </address>
                        <Link className="Contact__map" to={getMapUrl(location)}>Otevřít v Google Maps</Link>
                    </div>
                ))}
            </div>
        </Block>
    );
}
